import { render, staticRenderFns } from "./ResumenCesantia.vue?vue&type=template&id=48fbe9bc&scoped=true"
import script from "./ResumenCesantia.vue?vue&type=script&lang=ts"
export * from "./ResumenCesantia.vue?vue&type=script&lang=ts"
import style0 from "./ResumenCesantia.vue?vue&type=style&index=0&id=48fbe9bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fbe9bc",
  null
  
)

export default component.exports